import Icon from '../components/Icon.vue'

Icon.register({
  'file-medical-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M288 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-168h70.1l34.8 69.5c2.9 5.9 11.4 5.9 14.3 0l56.8-113.7 22.1 44.2h89.9c8.8 0 16-7.2 16-16s-7.2-16-16-16h-70.2l-34.7-69.5c-2.9-5.9-11.4-5.9-14.3 0l-56.8 113.7-19.9-39.8c-1.4-2.7-4.2-4.4-7.2-4.4h-140.9c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h56v-232c0-13.3 10.7-24 24-24h200v136zM441 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-medical-alt.js
// module id = 1340
// module chunks = 0